// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QBase 점검 배너 — 화면 맨 위 가운데. 로그인 만료 창(1500) 위에서도 보인다 */
.qbase-maint-banner {
  position: fixed;
  top: 4px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1600;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100vw / var(--app-zoom, 1) - 32px);
  padding: 5px 14px;
  font-size: 12.5px;
  line-height: 1.4;
  color: #7a4d00;
  background: #fff4e0;
  border: 1px solid #f0d8a8;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  animation: qbase-maint-in 160ms ease-out;
}
[data-theme="dark"] .qbase-maint-banner { color: #f0cf8f; background: #3a2f1c; border-color: #5c4a28; }

.qbase-maint-dot {
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e0a030;
}

@keyframes qbase-maint-in {
  from { opacity: 0; transform: translate(-50%, -3px); }
  to { opacity: 1; transform: translate(-50%, 0); }
}

@media (prefers-reduced-motion: reduce) {
  .qbase-maint-banner { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/QbaseMaintenanceBanner.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,wCAAwC;AAC1C;AACA,0CAA0C,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAEtG;EACE,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,gCAAgC,EAAE;EACrD,KAAK,UAAU,EAAE,6BAA6B,EAAE;AAClD;;AAEA;EACE,sBAAsB,eAAe,EAAE;AACzC","sourcesContent":["/* QBase 점검 배너 — 화면 맨 위 가운데. 로그인 만료 창(1500) 위에서도 보인다 */\n.qbase-maint-banner {\n  position: fixed;\n  top: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  max-width: calc(100vw / var(--app-zoom, 1) - 32px);\n  padding: 5px 14px;\n  font-size: 12.5px;\n  line-height: 1.4;\n  color: #7a4d00;\n  background: #fff4e0;\n  border: 1px solid #f0d8a8;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  animation: qbase-maint-in 160ms ease-out;\n}\n[data-theme=\"dark\"] .qbase-maint-banner { color: #f0cf8f; background: #3a2f1c; border-color: #5c4a28; }\n\n.qbase-maint-dot {\n  flex: none;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #e0a030;\n}\n\n@keyframes qbase-maint-in {\n  from { opacity: 0; transform: translate(-50%, -3px); }\n  to { opacity: 1; transform: translate(-50%, 0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .qbase-maint-banner { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
